/**
 * UTM 参数类型定义
 */
export interface UTMParams {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_term?: string
  utm_content?: string
}

/**
 * 从 URL 中解析 UTM 参数
 */
export function parseUTMFromURL(url?: string): UTMParams {
  try {
    const queryString = url || window.location.search
    const urlObj = new URL(queryString, window.location.origin)
    const params = new URLSearchParams(urlObj.search)

    return {
      utm_source: params.get('utm_source') || undefined,
      utm_medium: params.get('utm_medium') || undefined,
      utm_campaign: params.get('utm_campaign') || undefined,
      utm_term: params.get('utm_term') || undefined,
      utm_content: params.get('utm_content') || undefined,
    }
  } catch (error) {
    console.error('解析 UTM 参数失败:', error)
    return {}
  }
}

/**
 * 从 localStorage 获取存储的 UTM 参数
 */
export function getStoredUTM(): UTMParams {
  try {
    const stored = localStorage.getItem('utm_params')
    return stored ? JSON.parse(stored) : {}
  } catch (error) {
    console.error('获取存储的 UTM 参数失败:', error)
    return {}
  }
}

/**
 * 保存 UTM 参数到 localStorage
 * 只有当存在 UTM 参数时才保存，避免覆盖已有数据
 */
export function storeUTM(utmParams: UTMParams): void {
  try {
    // 如果有新的 UTM 参数，则保存
    if (Object.values(utmParams).some((value) => value)) {
      localStorage.setItem('utm_params', JSON.stringify(utmParams))
      localStorage.setItem('utm_timestamp', Date.now().toString())
    }
  } catch (error) {
    console.error('存储 UTM 参数失败:', error)
  }
}

/**
 * 获取 UTM 参数（优先从 URL 获取，其次从 localStorage）
 */
export function getUTMParams(): UTMParams {
  const urlParams = parseUTMFromURL()

  // 如果 URL 中有 UTM 参数，保存并返回
  if (Object.values(urlParams).some((value) => value)) {
    storeUTM(urlParams)
    return urlParams
  }

  // 否则返回存储的 UTM 参数
  return getStoredUTM()
}

/**
 * 清除 UTM 参数
 */
export function clearUTM(): void {
  try {
    localStorage.removeItem('utm_params')
    localStorage.removeItem('utm_timestamp')
  } catch (error) {
    console.error('清除 UTM 参数失败:', error)
  }
}

/**
 * 获取 UTM 参数的存储时间（毫秒）
 */
export function getUTMTimestamp(): number | null {
  try {
    const timestamp = localStorage.getItem('utm_timestamp')
    return timestamp ? parseInt(timestamp, 10) : null
  } catch (error) {
    console.error('获取 UTM 时间戳失败:', error)
    return null
  }
}
